import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u914467304/domains/wesleycarvalho.dev/hbuilds/source/repository/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u914467304/domains/wesleycarvalho.dev/hbuilds/source/repository/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
